import type { MouseEvent } from "react";
import { ButtonBase, Typography, useTheme } from "@mui/material";
import { RecordContextProvider } from "react-admin";
import { PaymentStatusField } from "../fields/PaymentStatusField";
import { Column } from "../misc/Column";
import { formatMoney } from "../misc/Money";
import { Row } from "../misc/Row";
import type { PerformanceOverviewRecord } from "../providers/performanceOverviewProvider";

export function PerformanceOverviewMobileListItem(props: {
  record: PerformanceOverviewRecord;
  onClick: (event: MouseEvent<HTMLDivElement>) => void;
}) {
  const { record, onClick } = props;
  const theme = useTheme();
  const people = [record.rawEntry.student_name, record.rawEntry.instructor_name].filter(Boolean);
  const details = [record.serviceAt.toFormat("dd.MM.yyyy"), ...people];

  return (
    <RecordContextProvider value={record}>
      <ButtonBase
        component="div"
        data-testid="PerformanceOverviewMobileListItem"
        onClick={onClick}
        role="button"
        tabIndex={0}
        sx={{
          alignItems: "stretch",
          borderBottom: `1px solid ${theme.palette.divider}`,
          boxSizing: "border-box",
          display: "block",
          px: 0,
          py: 1,
          textAlign: "left",
          width: "100%",
        }}
      >
        <Column sx={{ gap: 0.5, minWidth: 0 }}>
          <Row sx={{ alignItems: "flex-start", gap: 1, justifyContent: "space-between", minWidth: 0 }}>
            <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 0, overflowWrap: "anywhere" }}>
              {record.description}
            </Typography>
            <Typography variant="body2" sx={{ flexShrink: 0, fontWeight: 600 }}>
              {formatMoney(record.mainItemTotalPriceGross)}
            </Typography>
          </Row>
          <Typography variant="caption" color="text.secondary" sx={{ overflowWrap: "anywhere" }}>
            {details.join(" · ")}
          </Typography>
          <Row sx={{ alignItems: "center", gap: 1, justifyContent: "space-between", minWidth: 0 }}>
            {record.invoiceNumber && (
              <Typography variant="caption" color="text.secondary" noWrap sx={{ minWidth: 0 }}>
                Rechnung {record.invoiceNumber}
              </Typography>
            )}
            <PaymentStatusField source="paymentStatus" size="small" />
          </Row>
        </Column>
      </ButtonBase>
    </RecordContextProvider>
  );
}
